export default [
  {
    title: '购买方名称',
    fixed: 'left',
    dataIndex: 'buyerName',
    key: 'buyerName',
    width: 150
  },
  {
    title: '纳税识别号',
    dataIndex: 'buyerTaxNumber',
    key: 'buyerTaxNumber',
    width: 270
  },
  {
    title: '购买方类型',
    dataIndex: 'buyerType',
    key: 'buyerType',
    width: 120,
    scopedSlots: { customRender: 'buyerType' }
  },
  {
    title: '开票金额',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    width: 120,
    scopedSlots: { customRender: 'totalAmount' }
  },
  {
    title: '状态',
    width: 100,
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' }
  },
  {
    title: '发票类型',
    width: 140,
    dataIndex: 'invoiceType',
    key: 'invoiceType',
    scopedSlots: { customRender: 'invoiceType' }
  },
  {
    title: '发票内容',
    dataIndex: 'invoiceUrls',
    width: 100,
    key: 'invoiceUrls',
    scopedSlots: { customRender: 'invoiceUrls' }
  },
  {
    title: '邮箱',
    width: 220,
    dataIndex: 'email',
    key: 'email',
    scopedSlots: { customRender: 'email' }
  },
  {
    title: '是否变更',
    dataIndex: 'hasChanged',
    key: 'hasChanged',
    width: 70,
    scopedSlots: { customRender: 'hasChanged' }
  },
  {
    title: '是否撤销',
    dataIndex: 'needRevoke',
    key: 'needRevoke',
    width: 70,
    scopedSlots: { customRender: 'needRevoke' }
  },
  {
    title: '创建时间',
    width: 180,
    dataIndex: 'createdAt',
    key: 'createdAt'
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    fixed: 'right',
    scopedSlots: { customRender: 'action' }
  }
]
